import { render, staticRenderFns } from "./myArticle.vue?vue&type=template&id=ba4f047e&scoped=true&"
import script from "./myArticle.vue?vue&type=script&lang=js&"
export * from "./myArticle.vue?vue&type=script&lang=js&"
import style0 from "./myArticle.vue?vue&type=style&index=0&id=ba4f047e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4f047e",
  null
  
)

export default component.exports